import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=04be7844&scoped=true&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
import style0 from "./Admin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Admin.vue?vue&type=style&index=1&id=04be7844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be7844",
  null
  
)

export default component.exports